import type { FetchDataWrapperProps } from "./fetch-data-wrapper.type";

import { Alert, Empty, Spin } from "antd";
import { useTranslation } from "react-i18next";

import { isDataEmpty } from "@/utilities/data";

import "./fetch-data-wrapper.style.less";

const className = "fetch-data-wrapper";

export const FetchDataWrapper = <Data,>({
  data,
  error,
  loading,
  isEmpty,
  loader,
  emptyDescription,
  children,
}: FetchDataWrapperProps<Data>) => {
  const { t } = useTranslation();

  if (loading) {
    return <div className={`${className} -loading`}>{loader ?? <Spin />}</div>;
  }

  if (error) {
    return (
      <div className={`${className} -error`}>
        <Alert title={t("form:error:genericError")} type="error" showIcon />
      </div>
    );
  }

  if (isEmpty ?? isDataEmpty(data)) {
    return (
      <div className={`${className} -empty`}>
        <Empty description={emptyDescription} />
      </div>
    );
  }

  return children;
};
